import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Z1.css";

// ⭐ Example 5 rows data – replace with your images, headings & text
import img1 from "../assets/images/item10/subitm1.jpg";
import img2 from "../assets/images/item10/subitm2.jpg";
import img3 from "../assets/images/item10/subitm3.jpg";

const rowsData = [
  {
    id: 1,
    title: "Safety Footwear & Workwear",
    text: "Durable safety footwear and workwear for maximum protection at worksites.",
    img: img1,
    gradient: "gradient1",
    stars: 4,
    description: `Safety footwear and workwear protect workers from workplace hazards. Made with high-quality materials for comfort and durability. Resistant to impacts, chemicals, and extreme conditions.
`
  },
  {
    id: 2,
    title: "Fire Safety & Rescue Equipment",
    text: "Reliable fire safety and rescue equipment for quick emergency response.",
    img: img2,
    gradient: "gradient2",
    stars: 5,
    description: `Fire safety and rescue equipment ensures protection in case of fire emergencies. Includes extinguishers, fire suits, hoses, and rescue tools. Designed to handle high temperatures and critical situations.`
  },
  {
    id: 3,
    title: "General Safety & PPE'S",
    text: "High-quality PPE and general safety gear for personal and workplace protection.",
    img: img3,
    gradient: "gradient3",
    stars: 3,
    description: `Personal Protective Equipment (PPE) ensures safety in hazardous environments. Includes helmets, gloves, masks, goggles, and protective clothing. Provides defense against chemicals, dust, heat, and physical risks.`
  }
];

function Z10() {
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
            onClick={() => setSelectedRow(row)}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>
              <div className="stars">
                {"★".repeat(row.stars)}
                {"☆".repeat(5 - row.stars)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* 🔹 Popup / Modal */}
      {selectedRow && (
        <div className="z1-modal-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="z1-modal"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            <h2>{selectedRow.title}</h2>

            <div className="modal-body">
              <div className="modal-img">
                <img src={selectedRow.img} alt={selectedRow.title} />
              </div>
              <div className="modal-text">
                <p>{selectedRow.description}</p>
              </div>
            </div>

            <button
              className="close-btn"
              onClick={() => setSelectedRow(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Z10;